/** Interpreta `catalog_empty` del RPC solo en snapshots completos. */
export function catalogEmptyFromPayload(payload: {
  snapshot_complete?: boolean;
  catalog_empty?: boolean;
}): boolean | undefined {
  if (payload.snapshot_complete === true && typeof payload.catalog_empty === 'boolean') {
    return payload.catalog_empty;
  }
  return undefined;
}

export function isLocalCatalogEmpty(counts: { productsCount: number }): boolean {
  return counts.productsCount === 0;
}

export function isSellableCatalogEmpty(counts: { sellableProductsCount: number }): boolean {
  return counts.sellableProductsCount === 0;
}
